import { forwardRef, type Ref, type SVGProps } from "react";
const IconAutofillFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M29 7h-4v17h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1" />
    <path
      fill="currentColor"
      d="M23 5h3V3h-8v2h3v21h-3v2h8v-2h-3zM9.68 16h1.04l-.52-1.31z"
    />
    <path
      fill="currentColor"
      d="M3 7a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h16V7zm10.37 12.93a1 1 0 0 1-.932-.102 1 1 0 0 1-.368-.458L11.51 18H8.88l-.55 1.37a1 1 0 0 1-1.86-.74l2.8-7a1 1 0 0 1 1.86 0l2.8 7a1 1 0 0 1-.56 1.3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAutofillFilledSVG);
ForwardRef.displayName = "IconAutofillFilled";
export { ForwardRef as IconAutofillFilled };
